(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-service-type-attribute', {
            parent: 'entity',
            url: '/custom-service-type-attribute?page&sort&search',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ],
                pageTitle: 'trakeyeApp.customServiceTypeAttribute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-service-type-attribute/custom-service-type-attributes.html',
                    controller: 'CustomServiceTypeAttributeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customServiceTypeAttribute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-service-type-attribute-detail', {
            parent: 'custom-service-type-attribute',
            url: '/custom-service-type-attribute/{id}',
            data: {
                authorities:  [ 'ROLE_USER_ADMIN' ],
                pageTitle: 'trakeyeApp.customServiceTypeAttribute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-service-type-attribute/custom-service-type-attribute-detail.html',
                    controller: 'CustomServiceTypeAttributeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customServiceTypeAttribute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomServiceTypeAttribute', function($stateParams, CustomServiceTypeAttribute) {
                    return CustomServiceTypeAttribute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-service-type-attribute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('custom-service-type-attribute-detail.edit', {
            parent: 'custom-service-type-attribute-detail',
            url: '/detail/edit',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-service-type-attribute/custom-service-type-attribute-dialog.html',
                    controller: 'CustomServiceTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomServiceTypeAttribute', function(CustomServiceTypeAttribute) {
                            return CustomServiceTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
       /* .state('custom-service-type-attribute.new', {
            parent: 'custom-service-type-attribute',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-service-type-attribute/custom-service-type-attribute-dialog.html',
                    controller: 'CustomServiceTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custom-service-type-attribute', null, { reload: 'custom-service-type-attribute' });
                }, function() {
                    $state.go('custom-service-type-attribute');
                });
            }]
        })*/
        
        .state('custom-service-type-attribute.new', {
			parent : 'custom-service-type-attribute',
			url : '/new',
			data : {
				authorities : [ 'ROLE_USER_ADMIN' ]
			},
			views : {
				'content@' : {
					 templateUrl: 'app/entities/custom-service-type-attribute/custom-service-type-attribute-dialog.html',
	                    controller: 'CustomServiceTypeAttributeDialogController',
	                    controllerAs: 'vm',
				}
			},
			resolve : {
				entity : function() {
					return {
						name : null,
						description : null,
						id : null
					};
				}
			}
		})
        /*.state('custom-service-type-attribute.edit', {
            parent: 'custom-service-type-attribute',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-service-type-attribute/custom-service-type-attribute-dialog.html',
                    controller: 'CustomServiceTypeAttributeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomServiceTypeAttribute', function(CustomServiceTypeAttribute) {
                            return CustomServiceTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-service-type-attribute', null, { reload: 'custom-service-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
		
		.state('custom-service-type-attribute.edit', {
			parent : 'custom-service-type-attribute',
			url : '/{id}/edit',
			data : {
				authorities : [ 'ROLE_USER_ADMIN' ],
				pageTitle : 'trakeyeApp.customServiceTypeAttribute.home.title'
			},
			views : {
				'content@' : {
					templateUrl: 'app/entities/custom-service-type-attribute/custom-service-type-attribute-dialog.html',
                    controller: 'CustomServiceTypeAttributeDialogController',
                    controllerAs: 'vm',
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('customServiceTypeAttribute');
					return $translate.refresh();
				} ],
				entity : [ '$stateParams', 'CustomServiceTypeAttribute', function($stateParams, CustomServiceTypeAttribute) {
					return CustomServiceTypeAttribute.get({
						id : $stateParams.id
					}).$promise;
				} ],
				previousState : [ "$state", function($state) {
					var currentStateData = {
						name : $state.current.name || 'custom-service-type-attribute',
						params : $state.params,
						url : $state.href($state.current.name, $state.params)
					};
					return currentStateData;
				} ]
			}
		})
        .state('custom-service-type-attribute.delete', {
            parent: 'custom-service-type-attribute',
            url: '/{id}/delete',
            data: {
                authorities: [ 'ROLE_USER_ADMIN' ],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-service-type-attribute/custom-service-type-attribute-delete-dialog.html',
                    controller: 'CustomServiceTypeAttributeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomServiceTypeAttribute', function(CustomServiceTypeAttribute) {
                            return CustomServiceTypeAttribute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-service-type-attribute', null, { reload: 'custom-service-type-attribute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
